// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddPopularLocationManagement-space1-fiNX0 {
	margin-bottom: 6px !important;
}

.AddPopularLocationManagement-space2-frGP3 {
	margin-bottom: 12px !important;
}

.AddPopularLocationManagement-space3-VC3A0 {
	margin-bottom: 18px !important;
}

.AddPopularLocationManagement-space4-ee3Wf {
	margin-bottom: 24px !important;
}

.AddPopularLocationManagement-space5-OhLzk {
	margin-bottom: 30px !important;
}

.AddPopularLocationManagement-space6-EO7L3 {
	margin-bottom: 36px !important;
}

.AddPopularLocationManagement-space7-V83PY {
	margin-bottom: 42px !important;
}

.AddPopularLocationManagement-space8-AzR0u {
	margin-bottom: 48px !important;
}

.AddPopularLocationManagement-spaceTop1-mTAeK {
	margin-top: 6px !important;
}

.AddPopularLocationManagement-spaceTop2-DLaFe {
	margin-top: 12px !important;
}

.AddPopularLocationManagement-spaceTop3-tNG5Z {
	margin-top: 18px !important;
}

.AddPopularLocationManagement-spaceTop4-sDLZB {
	margin-top: 24px !important;
}

.AddPopularLocationManagement-spaceTop5-LWwup {
	margin-top: 30px !important;
}

.AddPopularLocationManagement-spaceTop6-DaH0O {
	margin-top: 36px !important;
}

.AddPopularLocationManagement-spaceTop7-zUdHk {
	margin-top: 42px !important;
}

.AddPopularLocationManagement-spaceTop8-E6u11 {
	margin-top: 48px !important;
}

.AddPopularLocationManagement-noMargin-v0RbN {
	margin: 0px !important;
}

.AddPopularLocationManagement-padding1-eb4LW {
	padding-bottom: 6px !important;
}

.AddPopularLocationManagement-padding2-ObJzo {
	padding-bottom: 12px !important;
}

.AddPopularLocationManagement-padding3-R_Z80 {
	padding-bottom: 18px !important;
}

.AddPopularLocationManagement-padding4-bkU8_ {
	padding-bottom: 24px !important;
}

.AddPopularLocationManagement-padding5-A3uWU {
	padding-bottom: 30px !important;
}

.AddPopularLocationManagement-padding6-Fdmhp {
	padding-bottom: 36px !important;
}

.AddPopularLocationManagement-padding7-BHYyR {
	padding-bottom: 42px !important;
}

.AddPopularLocationManagement-paddingTop1-Dz3Vg {
	padding-top: 6px !important;
}

.AddPopularLocationManagement-paddingTop2-Tlj1D {
	padding-top: 12px !important;
}

.AddPopularLocationManagement-paddingTop3-qVlfE {
	padding-top: 18px !important;
}

.AddPopularLocationManagement-paddingTop4-JyLJu {
	padding-top: 24px !important;
}

.AddPopularLocationManagement-paddingTop5-PtL0q {
	padding-top: 30px !important;
}

.AddPopularLocationManagement-paddingTop6-EkXpP {
	padding-top: 36px !important;
}

.AddPopularLocationManagement-paddingTop7-uplYG {
	padding-top: 42px !important;
}

.AddPopularLocationManagement-noPadding-VZ9hk {
	padding: 0px !important;
}

.AddPopularLocationManagement-spaceMarginBottom0-T4GsO {
	margin-bottom: 0;
}

.AddPopularLocationManagement-textBold-gJrNT {
	font-weight: 500 !important;
}

.AddPopularLocationManagement-textBolder-N8xVw {
	font-weight: 700 !important;
}

.AddPopularLocationManagement-textNormal-IsSf_ {
	font-weight: normal !important;
}

/*New Design Text Colors */

.AddPopularLocationManagement-textDarkBlue-ugamm {
	color: rgb(20, 39, 94) !important;
}

.AddPopularLocationManagement-textLightBlue-hmtAW {
	color: rgb(57, 87, 106) !important;
}

.AddPopularLocationManagement-textLightSandleGreen-wSA0N {
	color: rgb(76, 86, 41) !important;
}

.AddPopularLocationManagement-textLightBrown-dvQiP {
	color: rgb(115, 79, 33) !important;
}

.AddPopularLocationManagement-textMediumMaroon-j9aV7 {
	color: rgb(87, 37, 51) !important;
}

.AddPopularLocationManagement-textBrown-ntAfC {
	color: rgb(160, 47, 24) !important;
}

.AddPopularLocationManagement-textMaroon-eSmNd {
	color: rgb(155, 49, 67) !important;
}

.AddPopularLocationManagement-textDarkBrown-PLEH8 {
	color: rgb(83, 18, 16) !important;
}

.AddPopularLocationManagement-textMediumBrown-u9nRA {
	color: rgb(142, 28, 10) !important;
}

.AddPopularLocationManagement-textSkyBlue-YPJOh {
	color: rgb(37, 117, 141) !important;
}

.AddPopularLocationManagement-textGray-oNomA {
	color: rgb(77, 65, 51) !important;
}

.AddPopularLocationManagement-errorMessage-BSI9U {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.AddPopularLocationManagement-userText-zRTwd {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.AddPopularLocationManagement-panelHeader-qiRIs {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.AddPopularLocationManagement-exportSection-XHdLK {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.AddPopularLocationManagement-exportSectionGridSub-Ertvh {
	grid-template-columns: 50% 49% !important;
}

.AddPopularLocationManagement-exportText-_jOMc {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.AddPopularLocationManagement-exportLinkImg-raqYg {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.AddPopularLocationManagement-exportImg-jK_VZ {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.AddPopularLocationManagement-linkBtn-_lH_7 {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.AddPopularLocationManagement-table-y0oX7 {
	display: table;
}

.AddPopularLocationManagement-tableRow-vRSqv {
	display: table-row;
}

.AddPopularLocationManagement-tableCell-zqdOA {
	display: table-cell;
	float: none;
}

.AddPopularLocationManagement-formGroup-uucAE {
	margin-bottom: 6px;
}

.AddPopularLocationManagement-marginTop0-dE521 {
	margin-top: 0;
}

.AddPopularLocationManagement-marginBottom20-jthZF {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.AddPopularLocationManagement-bannerImageBg-mft_Z {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.AddPopularLocationManagement-bannerDelete-sirYu {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.AddPopularLocationManagement-exportLink-t7iv6 {
	padding-top: 10px;
	padding-right: 10px;
}

.AddPopularLocationManagement-seachContent-aybPU {
	padding-left: 0px;
	margin-bottom: 5px;
}

.AddPopularLocationManagement-marginBottom9-Yr6At {
	margin-bottom: 9px;
}

.AddPopularLocationManagement-spaceTop52-FUcD9 {
	margin-top: 52px;
}

.AddPopularLocationManagement-profileViewInner-V_61m {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.AddPopularLocationManagement-profileViewMain-gNLxd {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.AddPopularLocationManagement-profileViewlabel-kQ1Iy {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.AddPopularLocationManagement-profileViewMainContent-ZQr6M {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.AddPopularLocationManagement-reviewsFormStar-xcAHa {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.AddPopularLocationManagement-reviewsFormStar-xcAHa svg {
	cursor: pointer;
}

.AddPopularLocationManagement-addLanguageText-fSwhn {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.AddPopularLocationManagement-exportSection-XHdLK {
		grid-template-columns: 100%;
	}

	.AddPopularLocationManagement-spaceTop52-FUcD9 {
		margin-top: 18px;
	}

	.AddPopularLocationManagement-exportText-_jOMc {
		float: none;
		margin-top: 12px;
	}

	.AddPopularLocationManagement-exportSectionGridSub-Ertvh {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.AddPopularLocationManagement-profileViewlabel-kQ1Iy {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.AddPopularLocationManagement-profileViewMainContent-ZQr6M {
		width: 100%;
		text-align: center;
	}

	.AddPopularLocationManagement-panelHeader-qiRIs {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/

.AddPopularLocationManagement-popularLocationDivider-LxBUV {
    padding-bottom: 18px;
    border-bottom: 1px solid var(--primary-border);
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/siteadmin/AddPopularLocation/AddPopularLocationManagement.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E;;ACtN3E;IACI,oBAAoB;IACpB,8CAA8C;AAClD","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/","@import '../admin-common.css';\n\n.popularLocationDivider {\n    padding-bottom: 18px;\n    border-bottom: 1px solid var(--primary-border);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `AddPopularLocationManagement-space1-fiNX0`,
	"space2": `AddPopularLocationManagement-space2-frGP3`,
	"space3": `AddPopularLocationManagement-space3-VC3A0`,
	"space4": `AddPopularLocationManagement-space4-ee3Wf`,
	"space5": `AddPopularLocationManagement-space5-OhLzk`,
	"space6": `AddPopularLocationManagement-space6-EO7L3`,
	"space7": `AddPopularLocationManagement-space7-V83PY`,
	"space8": `AddPopularLocationManagement-space8-AzR0u`,
	"spaceTop1": `AddPopularLocationManagement-spaceTop1-mTAeK`,
	"spaceTop2": `AddPopularLocationManagement-spaceTop2-DLaFe`,
	"spaceTop3": `AddPopularLocationManagement-spaceTop3-tNG5Z`,
	"spaceTop4": `AddPopularLocationManagement-spaceTop4-sDLZB`,
	"spaceTop5": `AddPopularLocationManagement-spaceTop5-LWwup`,
	"spaceTop6": `AddPopularLocationManagement-spaceTop6-DaH0O`,
	"spaceTop7": `AddPopularLocationManagement-spaceTop7-zUdHk`,
	"spaceTop8": `AddPopularLocationManagement-spaceTop8-E6u11`,
	"noMargin": `AddPopularLocationManagement-noMargin-v0RbN`,
	"padding1": `AddPopularLocationManagement-padding1-eb4LW`,
	"padding2": `AddPopularLocationManagement-padding2-ObJzo`,
	"padding3": `AddPopularLocationManagement-padding3-R_Z80`,
	"padding4": `AddPopularLocationManagement-padding4-bkU8_`,
	"padding5": `AddPopularLocationManagement-padding5-A3uWU`,
	"padding6": `AddPopularLocationManagement-padding6-Fdmhp`,
	"padding7": `AddPopularLocationManagement-padding7-BHYyR`,
	"paddingTop1": `AddPopularLocationManagement-paddingTop1-Dz3Vg`,
	"paddingTop2": `AddPopularLocationManagement-paddingTop2-Tlj1D`,
	"paddingTop3": `AddPopularLocationManagement-paddingTop3-qVlfE`,
	"paddingTop4": `AddPopularLocationManagement-paddingTop4-JyLJu`,
	"paddingTop5": `AddPopularLocationManagement-paddingTop5-PtL0q`,
	"paddingTop6": `AddPopularLocationManagement-paddingTop6-EkXpP`,
	"paddingTop7": `AddPopularLocationManagement-paddingTop7-uplYG`,
	"noPadding": `AddPopularLocationManagement-noPadding-VZ9hk`,
	"spaceMarginBottom0": `AddPopularLocationManagement-spaceMarginBottom0-T4GsO`,
	"textBold": `AddPopularLocationManagement-textBold-gJrNT`,
	"textBolder": `AddPopularLocationManagement-textBolder-N8xVw`,
	"textNormal": `AddPopularLocationManagement-textNormal-IsSf_`,
	"textDarkBlue": `AddPopularLocationManagement-textDarkBlue-ugamm`,
	"textLightBlue": `AddPopularLocationManagement-textLightBlue-hmtAW`,
	"textLightSandleGreen": `AddPopularLocationManagement-textLightSandleGreen-wSA0N`,
	"textLightBrown": `AddPopularLocationManagement-textLightBrown-dvQiP`,
	"textMediumMaroon": `AddPopularLocationManagement-textMediumMaroon-j9aV7`,
	"textBrown": `AddPopularLocationManagement-textBrown-ntAfC`,
	"textMaroon": `AddPopularLocationManagement-textMaroon-eSmNd`,
	"textDarkBrown": `AddPopularLocationManagement-textDarkBrown-PLEH8`,
	"textMediumBrown": `AddPopularLocationManagement-textMediumBrown-u9nRA`,
	"textSkyBlue": `AddPopularLocationManagement-textSkyBlue-YPJOh`,
	"textGray": `AddPopularLocationManagement-textGray-oNomA`,
	"errorMessage": `AddPopularLocationManagement-errorMessage-BSI9U`,
	"userText": `AddPopularLocationManagement-userText-zRTwd`,
	"panelHeader": `AddPopularLocationManagement-panelHeader-qiRIs`,
	"exportSection": `AddPopularLocationManagement-exportSection-XHdLK`,
	"exportSectionGridSub": `AddPopularLocationManagement-exportSectionGridSub-Ertvh`,
	"exportText": `AddPopularLocationManagement-exportText-_jOMc`,
	"exportLinkImg": `AddPopularLocationManagement-exportLinkImg-raqYg`,
	"exportImg": `AddPopularLocationManagement-exportImg-jK_VZ`,
	"linkBtn": `AddPopularLocationManagement-linkBtn-_lH_7`,
	"table": `AddPopularLocationManagement-table-y0oX7`,
	"tableRow": `AddPopularLocationManagement-tableRow-vRSqv`,
	"tableCell": `AddPopularLocationManagement-tableCell-zqdOA`,
	"formGroup": `AddPopularLocationManagement-formGroup-uucAE`,
	"marginTop0": `AddPopularLocationManagement-marginTop0-dE521`,
	"marginBottom20": `AddPopularLocationManagement-marginBottom20-jthZF`,
	"bannerImageBg": `AddPopularLocationManagement-bannerImageBg-mft_Z`,
	"bannerDelete": `AddPopularLocationManagement-bannerDelete-sirYu`,
	"exportLink": `AddPopularLocationManagement-exportLink-t7iv6`,
	"seachContent": `AddPopularLocationManagement-seachContent-aybPU`,
	"marginBottom9": `AddPopularLocationManagement-marginBottom9-Yr6At`,
	"spaceTop52": `AddPopularLocationManagement-spaceTop52-FUcD9`,
	"profileViewInner": `AddPopularLocationManagement-profileViewInner-V_61m`,
	"profileViewMain": `AddPopularLocationManagement-profileViewMain-gNLxd`,
	"profileViewlabel": `AddPopularLocationManagement-profileViewlabel-kQ1Iy`,
	"profileViewMainContent": `AddPopularLocationManagement-profileViewMainContent-ZQr6M`,
	"reviewsFormStar": `AddPopularLocationManagement-reviewsFormStar-xcAHa`,
	"addLanguageText": `AddPopularLocationManagement-addLanguageText-fSwhn`,
	"popularLocationDivider": `AddPopularLocationManagement-popularLocationDivider-LxBUV`
};
module.exports = ___CSS_LOADER_EXPORT___;
